module.exports = __webpack_public_path__ + "media/parents/extracurricular-activities-08b9e111.svg";